module.exports = __webpack_public_path__ + "img/home_banner4.6e3729f1.jpg";